// TC rows must always carry this HSN (see the hint shown under the HSN box in UnitNameCell)
const TC_UNIT_HSN = "996519";

// Placeholder for fast data entry: 8 digits so it passes the 6-8 digit check, and obviously not a real code
export const DUMMY_HSN = "00000000";

export const isEmptyHsn = (value) => !String(value ?? "").trim();

export const getHsnForRow = (row, hsn) =>
  row?.unit_name === "TC" ? TC_UNIT_HSN : hsn;

// Returns a new dataSource with hsn applied to every row matching shouldUpdate(row, tableIndex, rowIndex)
export const fillHsn = ({ dataSource = [], hsn, shouldUpdate }) => {
  let updatedCount = 0;
  const nextDataSource = dataSource.map((table, tableIndex) => {
    let hasChanges = false;
    const nextTable = (table || []).map((row, rowIndex) => {
      if (!shouldUpdate(row, tableIndex, rowIndex)) {
        return row;
      }
      updatedCount += 1;
      hasChanges = true;
      return { ...row, hsn_sac: getHsnForRow(row, hsn) };
    });
    return hasChanges ? nextTable : table;
  });

  return { dataSource: nextDataSource, updatedCount };
};
